import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

interface PolicyDetailsData {
  policy: any;
  assetId: string;
  policyName: string;
}

@Component({
  selector: 'ssi-policy-details-dialog',
  templateUrl: './policy-details-dialog.component.html',
  styleUrls: ['./policy-details-dialog.component.scss'],
})
export class PolicyDetailsDialogComponent {
  conditionColumns: string[] = ['subject', 'name', 'predicate', 'value', 'issuers'];

  private predicateMap: { [key: string]: string } = {
    '>': '> (greater than)',
    '>=': '≥ (greater or equal)',
    '<': '< (less than)',
    '<=': '≤ (less or equal)',
    '=': '= (equals)',
    '!=': '≠ (not equals)',
    'in': '∈ (member of)',
    'not_in': '∉ (not member of)',
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PolicyDetailsData,
    private dialogRef: MatDialogRef<PolicyDetailsDialogComponent>,
    private snackBar: MatSnackBar
  ) {}

  getPredicateDisplay(predicate: string): string {
    return this.predicateMap[predicate] || predicate;
  }

  formatValue(value: any): string {
    if (Array.isArray(value)) {
      return `[${value.join(', ')}]`;
    }
    return String(value);
  }

  copyToClipboard(text: string): void {
    navigator.clipboard.writeText(text).then(() => {
      this.snackBar.open('Copied to clipboard', 'Close', { duration: 2000 });
    });
  }

  copyFullPolicy(): void {
    const json = JSON.stringify(this.data.policy, null, 2);
    navigator.clipboard.writeText(json).then(() => {
      this.snackBar.open('Policy JSON copied to clipboard', 'Close', { duration: 2000 });
    });
  }
}
